import { handleActions } from 'redux-actions';

import {
  updateCustomerSearchKey,
  updateCustomerSearchTerm,
  updateItemSearchKey,
  updateItemSearchTerm,
  updateItems,
  updateUserID,
  updateProductID,
  updateLang,
  initialiseState,
  updateCurrentPage,
  updateViewOption,
  updateClassName,
  updateItemsNumber,
  updateCollectionName,
  openCollectionModal,
  updateEmail
} from './actions';

const initialState = {
  userIDProp: '',
  productIDProp: '',
  langProp: 'EN',
  items: null,
  collectionName: '',
  search: {
    customerSearchKey: 'Name',
    customerSearchTerm: '',
    itemSearchKey: 'No',
    itemSearchTerm: '',
  },
  paging: {
    currentPage: 0,
  },
  viewOption: 'cards',
  className: true,
  itemsNumber: '50',
  collectionModal: false,
  email: ''
};

const reducer = handleActions(
  {
    [updateCustomerSearchKey.type]: (state, {payload}) => ({
      ...state,
      search: {
        ...state.search,
        customerSearchKey: payload,
      },
    }),

    [updateCustomerSearchTerm.type]: (state, {payload}) => ({
      ...state,
      search: {
        ...state.search,
        customerSearchTerm: payload,
      },
    }),

    [updateItemSearchKey.type]: (state, {payload}) => ({
      ...state,
      search: {
        ...state.search,
        itemSearchKey: payload,
      },
    }),

    [updateItemSearchTerm.type]: (state, {payload}) => ({
      ...state,
      search: {
        ...state.search,
        itemSearchTerm: payload,
      },
    }),

    [openCollectionModal.type]: (state, {payload}) => ({
      ...state,
      collectionModal: payload,
    }),

    [updateItems.type]: (state, {payload}) => ({
      ...state,
      items: payload,
    }),

    [updateCollectionName.type]: (state, {payload}) => ({
      ...state,
      collectionName: payload,
    }),

    [updateUserID.type]: (state, {payload}) => ({
      ...state,
      userIDProp: payload
    }),

    [updateEmail.type]: (state, {payload}) => ({
      ...state,
      email: payload
    }),

    [updateProductID.type]: (state, {payload}) => ({
      ...state,
      productIDProp: payload
    }),

    [updateLang.type]: (state, {payload}) => ({
      ...state,
      langProp: payload
    }),

    [updateCurrentPage.type]: (state, {payload}) => ({
      ...state,
      paging: {
        ...state.paging,
        currentPage: payload,
      }
    }),

    [updateViewOption.type]: (state, {payload}) => ({
      ...state,
      viewOption: payload
    }),

    [updateClassName.type]: (state, {payload}) => ({
      ...state,
      className: payload
    }),

    [updateItemsNumber.type]: (state, {payload}) => ({
      ...state,
      itemsNumber: payload
    }),

    [initialiseState.type]: (state, {payload}) => ({
      ...initialState,
    }),
  },
  {
    ...initialState,
  }
);

export default reducer;



// WEBPACK FOOTER //
// ./src/model/reducer.js